<form [formGroup]="schenkingFg">
  <div *ngIf="this.hasNLOnroerendeZaken">

      <snelstart-ui-number-form-control formControlName="betaaldeOverdrachtsbelasting"
                                        id="betaaldeOverdrachtsbelasting"
                                        label="Betaalde overdrachtsbelasting"
                                        [showAllDecimals]="false"
                                        align="right"
                                        prefix="€"
                                        class="me-1 custom-input-250"
                                        (change)="saveForm()"
      >
      </snelstart-ui-number-form-control>

      <snelstart-ui-number-form-control formControlName="heffingsgrondslagOverdrachtsbelasting"
                                        id="heffingsgrondslagOverdrachtsbelasting"
                                        label="Heffingsgrondslag overdrachtsbelasting"
                                        [showAllDecimals]="false"
                                        align="right"
                                        prefix="€"
                                        class="me-1 custom-input-250"
                                        (change)="saveForm()"
      >
      </snelstart-ui-number-form-control>

      <snelstart-ui-select-form-control formControlName="indicatieSchenkerVorigeEigenaar"
                                        label="Schenker was eigenaar onroerende zaak"
                                        [options]="optionsJaNee"
                                        class="me-1 custom-input-250"
                                        (change)="this.saveForm()"
      >
      </snelstart-ui-select-form-control>

      <snelstart-ui-date-form-control formControlName="datumJuridischeLevering"
                                      label="Juridische levering"
                                      class="me-1 custom-input-250"
                                      (change)="this.saveForm()"
      >
      </snelstart-ui-date-form-control>

  </div>
  <div *ngIf="!this.hasNLOnroerendeZaken">

      <snelstart-ui-number-form-control formControlName="belastingBetaaldInAnderLand"
                                        id="belastingBetaaldInAnderLand"
                                        label="Betaalde buitenlandse belasting"
                                        [showAllDecimals]="false"
                                        align="right"
                                        prefix="€"
                                        class="me-1 custom-input-250"
                                        (change)="saveForm()"
      >
      </snelstart-ui-number-form-control>

          <snelstart-ui-select-form-control formControlName="landCodeBetaaldInAnderLand"
                                            label="Land waar schenkbelasting betaald is"
                                            [options]="optionsLandcodes"
                                            class="me-1 custom-input-250"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>

  </div>
</form>
